import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ConfirmationModal, TextField } from '@folio/stripes/components';

const EmailTestModal = ({ open, onConfirm, onCancel, isLoading }) => {
  const [testEmail, setTestEmail] = useState('');

  const handleConfirm = () => {
    onConfirm(testEmail);
    setTestEmail('');
  };

  const handleCancel = () => {
    onCancel();
    setTestEmail('');
  };

  return (
    <ConfirmationModal
      open={open}
      heading={
        <FormattedMessage id="ui-tenant-settings.settings.emailSettings.testEmail.modal.title" />
      }
      message={
        <div>
          <p>
            <FormattedMessage id="ui-tenant-settings.settings.emailSettings.testEmail.modal.message" />
          </p>
          <TextField
            label={
              <FormattedMessage id="ui-tenant-settings.settings.emailSettings.testEmail.address" />
            }
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            fullWidth
            required
          />
        </div>
      }
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      confirmLabel={
        <FormattedMessage id="ui-tenant-settings.settings.emailSettings.testEmail.send" />
      }
      cancelLabel={<FormattedMessage id="stripes-core.button.cancel" />}
      isConfirmButtonDisabled={!testEmail}
    />
  );
};

EmailTestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default EmailTestModal;
